import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { language, lang, gifts } = this.props
    return (
      <div className="top">
        <div style={{ height: '9.9rem' }}></div>
        {/* <div className="time">2020.12.15-2020.12.19</div> */}        
        <div className="bd">
          <div className="des">
            {/* {language != 'ar' && <div dangerouslySetInnerHTML={{ __html: lang.ruleDes || "" }}></div>} */}
            {/* {language == 'ar' && <div dangerouslySetInnerHTML={{ __html: lang.ruleDes || "" }}></div>} */}
            <div className="eventgift">{lang.eventGift}</div>
            <div className="giftlist">
              {gifts && gifts.length > 0 && gifts.map((item, index) => {
                  // console.log(111, item)
                  // if (index > 2) {
                    return (
                      <div className="item">
                        <img className="giftIcon" src={item.image} />
                        <div className="gold">{item.gold}<img className="icon" src="/img/activity/202408tr/coin.png" /></div>
                      </div>
                    )
                  // }
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/202408tr/Top/index.js